// extracted by mini-css-extract-plugin
module.exports =  {"list":"LsyCS12NxTr2QOE7VEct"};